import { vModelText as _vModelText, createElementVNode as _createElementVNode, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "w100" }
const _hoisted_2 = {
  key: 0,
  class: "w100"
}
const _hoisted_3 = { class: "mt20 fr mr40" }
const _hoisted_4 = { class: "input-group" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("p", { class: "fl mt7 ml5 mr5" }, "~", -1)
const _hoisted_6 = { class: "input-group" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_9 = { key: 0 }
const _hoisted_10 = { key: 1 }
const _hoisted_11 = {
  key: 0,
  class: "w100 pad40"
}
const _hoisted_12 = { class: "fl mr40 ml40" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("p", { class: "fs12 fw600 mb10" }, "デバイス別アクセス", -1)
const _hoisted_14 = { class: "fl mr40 ml10" }
const _hoisted_15 = ["src"]
const _hoisted_16 = { class: "fl fs16 fw600 mt5" }
const _hoisted_17 = { key: 0 }
const _hoisted_18 = { key: 1 }
const _hoisted_19 = { class: "fl ml10" }
const _hoisted_20 = ["src"]
const _hoisted_21 = { class: "fl fs16 fw600 mt5" }
const _hoisted_22 = { key: 0 }
const _hoisted_23 = { key: 1 }
const _hoisted_24 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_25 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_26 = { class: "fl ml40 mr40" }
const _hoisted_27 = /*#__PURE__*/_createElementVNode("p", { class: "fs12 fw600 mb10" }, "デバイス別確定", -1)
const _hoisted_28 = { class: "fl mr40 ml10" }
const _hoisted_29 = ["src"]
const _hoisted_30 = { class: "fl fs16 fw600 mt5" }
const _hoisted_31 = { key: 0 }
const _hoisted_32 = { key: 1 }
const _hoisted_33 = { class: "fl ml10" }
const _hoisted_34 = ["src"]
const _hoisted_35 = { class: "fl fs16 fw600 mt5" }
const _hoisted_36 = { key: 0 }
const _hoisted_37 = { key: 1 }
const _hoisted_38 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_39 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_40 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_41 = { class: "w100 pad20" }
const _hoisted_42 = { class: "ml40 mt40" }
const _hoisted_43 = /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("span", { class: "fs14 fw600 centered ddgrey" }, " アクセスパラメータから分析(β版) ")
], -1)
const _hoisted_44 = [
  _hoisted_43
]
const _hoisted_45 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_46 = /*#__PURE__*/_createElementVNode("div", { class: "fl fs12 mt10 ml20" }, "どのパラメータから確定しているかを分析することができます。", -1)
const _hoisted_47 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_48 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_49 = { key: 0 }
const _hoisted_50 = {
  key: 1,
  class: "pad40"
}
const _hoisted_51 = { class: "input-group" }
const _hoisted_52 = /*#__PURE__*/_createElementVNode("p", { class: "fl mt7 ml5 mr5" }, "~", -1)
const _hoisted_53 = { class: "input-group" }
const _hoisted_54 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_55 = {
  key: 0,
  class: "mt20"
}
const _hoisted_56 = /*#__PURE__*/_createElementVNode("tbody", null, [
  /*#__PURE__*/_createElementVNode("tr", { style: {"line-height":"20px"} }, [
    /*#__PURE__*/_createElementVNode("th", { width: "180" }, [
      /*#__PURE__*/_createElementVNode("span", { class: "fw600 fs11 ml10" }, "キー")
    ]),
    /*#__PURE__*/_createElementVNode("th", { width: "220" }, [
      /*#__PURE__*/_createElementVNode("span", { class: "fw600 fs11 ml10" }, "バリュー")
    ]),
    /*#__PURE__*/_createElementVNode("th", {
      width: "140",
      class: "centered"
    }, [
      /*#__PURE__*/_createElementVNode("span", { class: "fw600 fs11" }, "流入ユーザー数")
    ]),
    /*#__PURE__*/_createElementVNode("th", {
      width: "140",
      class: "centered"
    }, [
      /*#__PURE__*/_createElementVNode("span", { class: "fw600 fs11" }, "確定数")
    ]),
    /*#__PURE__*/_createElementVNode("th", {
      width: "140",
      class: "centered"
    }, [
      /*#__PURE__*/_createElementVNode("span", { class: "fw600 fs11" }, "確定率")
    ])
  ])
], -1)
const _hoisted_57 = {
  class: "fs14",
  style: {"padding":"0 10px","border-right":"1px solid #ddd"}
}
const _hoisted_58 = {
  class: "fs14",
  style: {"padding":"0 10px","border-right":"1px solid #ddd"}
}
const _hoisted_59 = { class: "fs20 centered" }
const _hoisted_60 = { class: "fs20" }
const _hoisted_61 = /*#__PURE__*/_createElementVNode("span", { class: "fs13" }, "件", -1)
const _hoisted_62 = { class: "fs20 centered" }
const _hoisted_63 = { class: "fs20" }
const _hoisted_64 = /*#__PURE__*/_createElementVNode("span", { class: "fs13" }, "件", -1)
const _hoisted_65 = { class: "fs20 centered" }
const _hoisted_66 = { class: "fs20" }
const _hoisted_67 = /*#__PURE__*/_createElementVNode("span", { class: "fs13" }, "%", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DatePicker = _resolveComponent("DatePicker")!
  const _component_Dropdown = _resolveComponent("Dropdown")!
  const _component_RoomsLoader = _resolveComponent("RoomsLoader")!
  const _component_GChart = _resolveComponent("GChart")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.dailyStats)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_component_Dropdown, {
              class: "form-group fl",
              style: {"width":"140px"}
            }, {
              dropdown: _withCtx(() => [
                _createElementVNode("li", null, [
                  _createVNode(_component_DatePicker, {
                    modelValue: _ctx.startDate,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.startDate) = $event)),
                    format: "yyyy/MM/dd",
                    "today-btn": false,
                    "clear-btn": false
                  }, null, 8, ["modelValue"])
                ])
              ]),
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_4, [
                  _withDirectives(_createElementVNode("input", {
                    class: "form-control dropdown-toggle",
                    type: "text",
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.startDate) = $event))
                  }, null, 512), [
                    [_vModelText, _ctx.startDate]
                  ])
                ])
              ]),
              _: 1
            }),
            _hoisted_5,
            _createVNode(_component_Dropdown, {
              class: "form-group fl",
              style: {"width":"140px"}
            }, {
              dropdown: _withCtx(() => [
                _createElementVNode("li", null, [
                  _createVNode(_component_DatePicker, {
                    modelValue: _ctx.endDate,
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.endDate) = $event)),
                    format: "yyyy/MM/dd",
                    "today-btn": false,
                    "clear-btn": false
                  }, null, 8, ["modelValue"])
                ])
              ]),
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_6, [
                  _withDirectives(_createElementVNode("input", {
                    class: "form-control dropdown-toggle",
                    type: "text",
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.endDate) = $event))
                  }, null, 512), [
                    [_vModelText, _ctx.endDate]
                  ])
                ])
              ]),
              _: 1
            }),
            _createElementVNode("button", {
              class: "fr pointer centered circle_button fs14 rad8 noborder ml10",
              style: {"height":"36px"},
              onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.changeTimeRange && _ctx.changeTimeRange(...args)))
            }, " 変更 "),
            _hoisted_7,
            _createElementVNode("button", {
              class: "fr pointer centered circle_button fs14 rad8 noborder",
              style: {"height":"50px"},
              onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.downloadStats && _ctx.downloadStats(...args)))
            }, " ダウンロード ")
          ]),
          _hoisted_8,
          (_ctx.loading)
            ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                _createVNode(_component_RoomsLoader)
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_10, [
                _createVNode(_component_GChart, {
                  class: "mt20",
                  style: `height: 360px;`,
                  type: `AreaChart`,
                  data: _ctx.chartStats,
                  options: _ctx.chartOptions,
                  createChart: 
                        (el, google, type) => {
                            return new google.visualization[type](el)
                        }
                    
                }, null, 8, ["data", "options", "createChart"]),
                (_ctx.showDeviceRasioContent)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                      _createElementVNode("div", _hoisted_12, [
                        _hoisted_13,
                        _createElementVNode("div", null, [
                          _createElementVNode("div", _hoisted_14, [
                            _createElementVNode("img", {
                              src: _ctx.$getAssetImageUrl(`/assets/icons/pc.png`),
                              width: "30",
                              height: "30",
                              class: "fl mr10"
                            }, null, 8, _hoisted_15),
                            _createElementVNode("p", _hoisted_16, [
                              (_ctx.totalDeviceNum != 0)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_17, _toDisplayString(_ctx.round((_ctx.dailyStats.total_pc_num * 100) / _ctx.totalDeviceNum, 2)) + "%", 1))
                                : (_openBlock(), _createElementBlock("span", _hoisted_18, "- %"))
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_19, [
                            _createElementVNode("img", {
                              src: _ctx.$getAssetImageUrl(`/assets/icons/call.png`),
                              width: "35",
                              height: "35",
                              class: "fl mr10",
                              style: {"margin-top":"-3px"}
                            }, null, 8, _hoisted_20),
                            _createElementVNode("p", _hoisted_21, [
                              (_ctx.totalDeviceNum != 0)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_22, _toDisplayString(_ctx.round((_ctx.dailyStats.total_sp_num * 100) / _ctx.totalDeviceNum, 2)) + "%", 1))
                                : (_openBlock(), _createElementBlock("span", _hoisted_23, "- %"))
                            ])
                          ]),
                          _hoisted_24
                        ]),
                        _hoisted_25
                      ]),
                      _createElementVNode("div", _hoisted_26, [
                        _hoisted_27,
                        _createElementVNode("div", null, [
                          _createElementVNode("div", _hoisted_28, [
                            _createElementVNode("img", {
                              src: _ctx.$getAssetImageUrl(`/assets/icons/pc.png`),
                              width: "30",
                              height: "30",
                              class: "fl mr10"
                            }, null, 8, _hoisted_29),
                            _createElementVNode("p", _hoisted_30, [
                              (_ctx.totalFixedDeviceNum != 0)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_31, _toDisplayString(_ctx.round((_ctx.dailyStats.total_fixed_pc_num * 100) / _ctx.totalFixedDeviceNum, 2)) + "%", 1))
                                : (_openBlock(), _createElementBlock("span", _hoisted_32, "- %"))
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_33, [
                            _createElementVNode("img", {
                              src: _ctx.$getAssetImageUrl(`/assets/icons/call.png`),
                              width: "35",
                              height: "35",
                              class: "fl mr10",
                              style: {"margin-top":"-3px"}
                            }, null, 8, _hoisted_34),
                            _createElementVNode("p", _hoisted_35, [
                              (_ctx.totalFixedDeviceNum != 0)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_36, _toDisplayString(_ctx.round((_ctx.dailyStats.total_fixed_sp_num * 100) / _ctx.totalFixedDeviceNum, 2)) + "%", 1))
                                : (_openBlock(), _createElementBlock("span", _hoisted_37, "- %"))
                            ])
                          ]),
                          _hoisted_38
                        ]),
                        _hoisted_39
                      ]),
                      _hoisted_40
                    ]))
                  : _createCommentVNode("", true)
              ]))
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_41, [
      _createElementVNode("div", _hoisted_42, [
        _createElementVNode("button", {
          class: _normalizeClass(`fl pointer centered circle_button fs16 rad8 mt15 ml20`),
          onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.clickAccessKeywordsStats && _ctx.clickAccessKeywordsStats(...args)))
        }, _hoisted_44),
        _hoisted_45,
        _hoisted_46,
        _hoisted_47
      ]),
      _hoisted_48,
      (_ctx.loadingAccessKeywordsStats)
        ? (_openBlock(), _createElementBlock("div", _hoisted_49, [
            _createVNode(_component_RoomsLoader)
          ]))
        : (_ctx.showAccessKeywordsStats)
          ? (_openBlock(), _createElementBlock("div", _hoisted_50, [
              _createVNode(_component_Dropdown, {
                class: "form-group fl",
                style: {"width":"140px"}
              }, {
                dropdown: _withCtx(() => [
                  _createElementVNode("li", null, [
                    _createVNode(_component_DatePicker, {
                      modelValue: _ctx.accessKeywordsStartDate,
                      "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.accessKeywordsStartDate) = $event)),
                      format: "yyyy/MM/dd",
                      "today-btn": false,
                      "clear-btn": false
                    }, null, 8, ["modelValue"])
                  ])
                ]),
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_51, [
                    _withDirectives(_createElementVNode("input", {
                      class: "form-control dropdown-toggle",
                      type: "text",
                      "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.accessKeywordsStartDate) = $event))
                    }, null, 512), [
                      [_vModelText, _ctx.accessKeywordsStartDate]
                    ])
                  ])
                ]),
                _: 1
              }),
              _hoisted_52,
              _createVNode(_component_Dropdown, {
                class: "form-group fl",
                style: {"width":"140px"}
              }, {
                dropdown: _withCtx(() => [
                  _createElementVNode("li", null, [
                    _createVNode(_component_DatePicker, {
                      modelValue: _ctx.accessKeywordsEndDate,
                      "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.accessKeywordsEndDate) = $event)),
                      format: "yyyy/MM/dd",
                      "today-btn": false,
                      "clear-btn": false
                    }, null, 8, ["modelValue"])
                  ])
                ]),
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_53, [
                    _withDirectives(_createElementVNode("input", {
                      class: "form-control dropdown-toggle",
                      type: "text",
                      "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.accessKeywordsEndDate) = $event))
                    }, null, 512), [
                      [_vModelText, _ctx.accessKeywordsEndDate]
                    ])
                  ])
                ]),
                _: 1
              }),
              _createElementVNode("button", {
                class: "fl ml10 pointer centered circle_button fs14 rad8 noborder",
                style: {"height":"36px"},
                onClick: _cache[11] || (_cache[11] = 
//@ts-ignore
(...args) => (_ctx.changeTimeRangeAccessKeywords && _ctx.changeTimeRangeAccessKeywords(...args)))
              }, " 変更 "),
              _hoisted_54,
              (_ctx.accessKeywordsStats)
                ? (_openBlock(), _createElementBlock("div", _hoisted_55, [
                    _createElementVNode("table", null, [
                      _hoisted_56,
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.accessKeywordsStats, (stat, index) => {
                        return (_openBlock(), _createElementBlock("tr", {
                          height: "50",
                          class: "hoverLgreyBg",
                          key: index
                        }, [
                          _createElementVNode("td", _hoisted_57, _toDisplayString(stat[0]), 1),
                          _createElementVNode("td", _hoisted_58, _toDisplayString(stat[1]), 1),
                          _createElementVNode("td", _hoisted_59, [
                            _createElementVNode("span", _hoisted_60, _toDisplayString(stat[2]), 1),
                            _hoisted_61
                          ]),
                          _createElementVNode("td", _hoisted_62, [
                            _createElementVNode("span", _hoisted_63, _toDisplayString(stat[3]), 1),
                            _hoisted_64
                          ]),
                          _createElementVNode("td", _hoisted_65, [
                            _createElementVNode("span", _hoisted_66, _toDisplayString(stat[3] === 0 ? "0" : ((stat[3] / stat[2]) * 100).toFixed(1)), 1),
                            _hoisted_67
                          ])
                        ]))
                      }), 128))
                    ])
                  ]))
                : _createCommentVNode("", true)
            ]))
          : _createCommentVNode("", true)
    ])
  ]))
}